import type { FaireProductEntity } from "../../entity_types/product";

export const p_sn2h8xyxvb: FaireProductEntity = {
  token: "p_sn2h8xyxvb",
  type: "product",
  name: "Teakwood Buddha Carved - 14mm",
  brandToken: "b_v58tcqg42w",
  brandName: "Now N Zen",
  imageUrl:
    "https://cdn.faire.com/fastly/8f613e7305fb8819af5706465cac8bfde415707548f9b4a15c96a9a61c3bac0e.jpeg",
  galleryImageUrls: [],
  priceDollars: 12.47,
  description: "",
  tags: [],
  msrpDollars: 24.94,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:58:57.773Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
